// =========== ACTIONS ===========
export const ADD_INS_USER = "ADD_INS_USER";
export const SHOW_SEARCH_OR_LOGIN = "SHOW_SEARCH_OR_LOGIN";
export const LOGIN_BY_INS = "LOGIN_BY_INS";
export const LOGIN_BY_FB = "LOGIN_BY_FB";
export const LOGIN_RES_RESOLVE = "LOGIN_RES_RESOLVE";
export const HANLDE_CHALLENGE = "HANLDE_CHALLENGE";
export const LOGIN_SUCCESS_RESOLVE = "LOGIN_SUCCESS_RESOLVE";
export const ADD_INS_USER_INFO = "ADD_INS_USER_INFO";
export const REFRESH_CURRENT_INS_UNSR_INFO = "REFRESH_CURRENT_INS_UNSR_INFO";
export const LOGIN_BY_FB_ERROR_TOAST = "LOGIN_BY_FB_ERROR_TOAST";
export const INS_CHALLANGER_VERFIY_LOGIN = "INS_CHALLANGER_VERFIY_LOGIN";
export const INS_TWOFACTORY_VERFIY_LOGIN = "INS_TWOFACTORY_VERFIY_LOGIN";
export const FETCH_INS_USER_INFO = "FETCH_INS_USER_INFO";
export const DELETE_INS_USER = "DELETE_INS_USER";
export const REFRESH_ONE_INS_USER_INFO = "REFRESH_ONE_INS_USER_INFO";
export const HANDLE_ADD_USER_SUCCESS = "HANDLE_ADD_USER_SUCCESS";
export const SEARCH_INS_USER = "SEARCH_INS_USER";
export const UPDATE_EARN_COINS_ACT_USER_INFO =
  "UPDATE_EARN_COINS_ACT_USER_INFO";
export const SUPPLEMENT_INS_USER_INFO = "SUPPLEMENT_INS_USER_INFO";
// =========== MUTATIONS ===========
export const UPDATE_INS_USER_INFO = "UPDATE_INS_USER_INFO";
export const DELETE_INS_USER_INFO = "DELETE_INS_USER_INFO";
export const CLEAR_INS_USER_INFO = "CLEAR_INS_USER_INFO";
// =========== GETTERS ===========
export const GETTER_CURRENT_INS_USER_INFO = "GETTER_CURRENT_INS_USER_INFO";
export const GETTER_INS_USER_INFO_LIST = "GETTER_INS_USER_INFO_LIST";
export const GETTER_ONE_INS_LOGIN_USER_ID = "GETTER_ONE_INS_LOGIN_USER_ID";
export const GETTER_LOGIN_INS_USER_LIST = "GETTER_LOGIN_INS_USER_LIST";
export const GETTER_INS_USER_INFO_BY_ID = "GETTER_INS_USER_INFO_BY_ID";
export const GETTER_API_LOGIN_USER_ID = "GETTER_API_LOGIN_USER_ID";
export const GETTER_NOT_VERFY_USER_ID = "GETTER_NOT_VERFY_USER_ID";
